// @flow
export { default } from './CategoryEditItem';



// WEBPACK FOOTER //
// ./src/components/write/CategoryEditItem/index.js